// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__qbz0B","avatar--small":"Avatar_avatar--small__tY6gG","avatar--large":"Avatar_avatar--large__yT0w3"};